<template>
  <div class="sub1">

    <lnb></lnb>

    <!--SECTION-->
    <section class="sec1">
      <img src="img/visual_sub1.png" alt="" class="bg">
    </section>


    <!--SECTION-->
    <section class="sec2">
      <div class="pink_box rellax" data-rellax-speed="-1" data-rellax-percentage="0"></div>
      <img src="img/pic_weddingservice.png" alt="" class="pic1 rellax" data-rellax-speed="1" data-rellax-percentage="0">
      <img src="img/txt_mark-.png" alt="" class="txt_mark1 rellax" data-rellax-speed="-0.5" data-rellax-percentage="-.5">
      <img src="img/txt_mark_.png" alt="" class="txt_mark2 rellax" data-rellax-speed="-0.5" data-rellax-percentage="-.5">
      <img src="img/txt_weddingservice_title.png" alt="" class="title1 rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/txt_weddingservice_desc.png" alt="" class="desc1 rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/mark_jimmy_pink.png" alt="" class="mark_jimmy rellax" data-rellax-speed="-2" data-rellax-percentage="1">
      <img src="img/txt_madetoorder_desc.png" alt="" class="desc2 rellax" data-rellax-speed="1" data-rellax-percentage="1">
      <img src="img/pic_history.png" alt="" class="pic2 rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/txt_side.png" alt="" class="txt_side rellax" data-rellax-speed="2" data-rellax-percentage="0">
      <img src="img/txt_history.png" alt="" class="desc3 rellax" data-rellax-speed=".5" data-rellax-percentage="0">
    </section>


    <!--SECTION-->
    <section class="sec3">
      <img src="img/pic_storestorage.png" alt="" class="pic rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <div class="pink_box1 rellax" data-rellax-speed=".5" data-rellax-percentage="0"></div>
      <img src="img/mark_c_pink.png" alt="" class="mark_c rellax" data-rellax-speed="-2" data-rellax-percentage="1">
      <img src="img/txt_storestorage.png" alt="" class="desc rellax" data-rellax-speed=".5" data-rellax-percentage="0">
      <img src="img/mark_h_white.png" alt="" class="mark_h rellax" data-rellax-speed="2" data-rellax-percentage="0">
    </section>


    <!--SECTION-->
    <section class="sec4">
      <img src="img/txt_side.png" alt="" class="txt_side rellax" data-rellax-speed="2" data-rellax-percentage="0">
      <img src="img/pic_awards.png" alt="" class="pic rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/mark_o_pink.png" alt="" class="mark_o rellax" data-rellax-speed="1" data-rellax-percentage="0">
      <img src="img/txt_awards.png" alt="" class="desc rellax" data-rellax-speed="3" data-rellax-percentage="0">
    </section>


    <!--SECTION-->
    <section class="sec5">
      <img src="img/pic_sandrachoi1.png" alt="" class="pic1 rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_mark-.png" alt="" class="txt_mark1 rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/txt_mark_.png" alt="" class="txt_mark2 rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/txt_sandrachoi_title.png" alt="" class="title rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/txt_sandrachoi_desc.png" alt="" class="desc1 rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/pic_sandrachoi2.png" alt="" class="pic2 rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <div class="pink_box3 rellax" data-rellax-speed="-2" data-rellax-percentage="0"></div>
      <img src="img/mark_o_white.png" alt="" class="mark_o rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/txt_sandrachoi_desc2.png" alt="" class="desc2 rellax" data-rellax-speed="0" data-rellax-percentage="0">
    </section>


  </div>
</template>

<script>
  import Lnb from './Lnb.vue'

  export default {
    name: 'Sub1Page',
    components: {
      Lnb
    },
    data () {
      return {

      }
    },
    mounted () {
      new Rellax('.rellax');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sub1Page.vue